import calendarCz from './cz.json';
import calendarDe from './de.json';
import calendarFr from './fr.json';
import calendarUs from './us.json';
import calendarVn from './vn.json';

// services
import errorHandlerServiceCz from '../../../services/error-handler-service/i18n/cz.json';
import errorHandlerServiceDe from '../../../services/error-handler-service/i18n/de.json';
import errorHandlerServiceFr from '../../../services/error-handler-service/i18n/fr.json';
import errorHandlerServiceUs from '../../../services/error-handler-service/i18n/us.json';
import errorHandlerServiceVn from '../../../services/error-handler-service/i18n/vn.json';

// pipes
import pipesCz from '../../../pipes/i18n/cz.json';
import pipesDe from '../../../pipes/i18n/de.json';
import pipesFr from '../../../pipes/i18n/fr.json';
import pipesUs from '../../../pipes/i18n/us.json';
import pipesVn from '../../../pipes/i18n/vn.json';

// components
import customerFormCz from '../../customer-form/i18n/cz.json';
import customerFormDe from '../../customer-form/i18n/de.json';
import customerFormFr from '../../customer-form/i18n/fr.json';
import customerFormUs from '../../customer-form/i18n/us.json';
import customerFormVn from '../../customer-form/i18n/vn.json';
import customerFormDialogCz from '../../customer-form-dialog/i18n/cz.json';
import customerFormDialogDe from '../../customer-form-dialog/i18n/de.json';
import customerFormDialogFr from '../../customer-form-dialog/i18n/fr.json';
import customerFormDialogUs from '../../customer-form-dialog/i18n/us.json';
import customerFormDialogVn from '../../customer-form-dialog/i18n/vn.json';
import customerSelectionFormCz from '../../customer-selection-form/i18n/cz.json';
import customerSelectionFormDe from '../../customer-selection-form/i18n/de.json';
import customerSelectionFormFr from '../../customer-selection-form/i18n/fr.json';
import customerSelectionFormUs from '../../customer-selection-form/i18n/us.json';
import customerSelectionFormVn from '../../customer-selection-form/i18n/vn.json';
import durationFormCz from '../../duration-form/i18n/cz.json';
import durationFormDe from '../../duration-form/i18n/de.json';
import durationFormFr from '../../duration-form/i18n/fr.json';
import durationFormUs from '../../duration-form/i18n/us.json';
import durationFormVn from '../../duration-form/i18n/vn.json';
import errorMessageWrapperCz from '../../core-layout/error-message-wrapper/i18n/cz.json';
import errorMessageWrapperDe from '../../core-layout/error-message-wrapper/i18n/de.json';
import errorMessageWrapperFr from '../../core-layout/error-message-wrapper/i18n/fr.json';
import errorMessageWrapperUs from '../../core-layout/error-message-wrapper/i18n/us.json';
import errorMessageWrapperVn from '../../core-layout/error-message-wrapper/i18n/vn.json';
import phoneNumberInputCz from '../../phone-number-input/i18n/cz.json';
import phoneNumberInputDe from '../../phone-number-input/i18n/de.json';
import phoneNumberInputFr from '../../phone-number-input/i18n/fr.json';
import phoneNumberInputUs from '../../phone-number-input/i18n/us.json';
import phoneNumberInputVn from '../../phone-number-input/i18n/vn.json';
import salonServiceSelectionCz from '../../salon-service-selection/i18n/cz.json';
import salonServiceSelectionDe from '../../salon-service-selection/i18n/de.json';
import salonServiceSelectionFr from '../../salon-service-selection/i18n/fr.json';
import salonServiceSelectionUs from '../../salon-service-selection/i18n/us.json';
import salonServiceSelectionVn from '../../salon-service-selection/i18n/vn.json';
import serviceSelectionFormCz from '../../service-selection-form/i18n/cz.json';
import serviceSelectionFormDe from '../../service-selection-form/i18n/de.json';
import serviceSelectionFormFr from '../../service-selection-form/i18n/fr.json';
import serviceSelectionFormUs from '../../service-selection-form/i18n/us.json';
import serviceSelectionFormVn from '../../service-selection-form/i18n/vn.json';
import staffSelectionFormCz from '../../staff-selection-form/i18n/cz.json';
import staffSelectionFormDe from '../../staff-selection-form/i18n/de.json';
import staffSelectionFormFr from '../../staff-selection-form/i18n/fr.json';
import staffSelectionFormUs from '../../staff-selection-form/i18n/us.json';
import staffSelectionFormVn from '../../staff-selection-form/i18n/vn.json';

export class CalendarLocalization {
  public static getCzLanguageSet() {
    return {
      ...calendarCz,
      // services
      ...errorHandlerServiceCz,
      // pipes
      ...pipesCz,
      // components
      ...customerFormCz,
      ...customerFormDialogCz,
      ...customerSelectionFormCz,
      ...durationFormCz,
      ...errorMessageWrapperCz,
      ...phoneNumberInputCz,
      ...salonServiceSelectionCz,
      ...serviceSelectionFormCz,
      ...staffSelectionFormCz,
    };
  }

  public static getDeLanguageSet() {
    return {
      ...calendarDe,
      // services
      ...errorHandlerServiceDe,
      // pipes
      ...pipesDe,
      // components
      ...customerFormDe,
      ...customerFormDialogDe,
      ...customerSelectionFormDe,
      ...durationFormDe,
      ...errorMessageWrapperDe,
      ...phoneNumberInputDe,
      ...salonServiceSelectionDe,
      ...serviceSelectionFormDe,
      ...staffSelectionFormDe,
    };
  }

  public static getFrLanguageSet() {
    return {
      ...calendarFr,
      // services
      ...errorHandlerServiceFr,
      // pipes
      ...pipesFr,
      // components
      ...customerFormFr,
      ...customerFormDialogFr,
      ...customerSelectionFormFr,
      ...durationFormFr,
      ...errorMessageWrapperFr,
      ...phoneNumberInputFr,
      ...salonServiceSelectionFr,
      ...serviceSelectionFormFr,
      ...staffSelectionFormFr,
    };
  }

  public static getUsLanguageSet() {
    return {
      ...calendarUs,
      // services
      ...errorHandlerServiceUs,
      // pipes
      ...pipesUs,
      // components
      ...customerFormUs,
      ...customerFormDialogUs,
      ...customerSelectionFormUs,
      ...durationFormUs,
      ...errorMessageWrapperUs,
      ...phoneNumberInputUs,
      ...salonServiceSelectionUs,
      ...serviceSelectionFormUs,
      ...staffSelectionFormUs,
    };
  }

  public static getVnLanguageSet() {
    return {
      ...calendarVn,
      // services
      ...errorHandlerServiceVn,
      // pipes
      ...pipesVn,
      // components
      ...customerFormVn,
      ...customerFormDialogVn,
      ...customerSelectionFormVn,
      ...durationFormVn,
      ...errorMessageWrapperVn,
      ...phoneNumberInputVn,
      ...salonServiceSelectionVn,
      ...serviceSelectionFormVn,
      ...staffSelectionFormVn,
    };
  }
}
